<template>
    <v-container>
        <v-row>
            <v-col cols="12" sm="12" md="6" lg="4" v-for="medic in medics" :key="medic.id">
                <MedicCard :medic="medic"></MedicCard>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import db from "../db";
    import MedicCard from "../components/MedicCard";
    export default {
        name: "MeetTheMedics",
        components: {
            MedicCard
        },
        data () {
            return {
                medics: []
            }
        },
        mounted() {
            db.collection("medics").get().then(snapshot => {
                snapshot.forEach(doc => {
                    let snapData = [];
                    snapshot.forEach(doc => {
                        snapData.push({
                            id: doc.id,
                            title: doc.data().title,
                            fullName: doc.data().firstName + ' ' + doc.data().lastName,
                            background: doc.data().background,
                            profilePic: doc.data().profilePic
                        })
                    });
                    this.medics = snapData;
                })
            })
        }
    }
</script>

<style scoped>

</style>
